import React from 'react';

import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PieChart, Pie, Cell } from 'recharts';


export const AccessibilityNoteContainer = ({notes}) => {

  const {t} = useTranslation();

  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column'
    },
    labelContainer: {
      marginTop: '1em'
    }
  };
  
  const renderColorNotes = () => {
    if ( notes >= 75 ) {
      return '#4CAF50';
    }
    if ( notes >=50 && notes < 75 ) {
      return '#FFD700';
    }
    if ( notes < 50 && notes >= 25 ) {
      return '#FFA500';
    } else {
      return '#FF0000';
    }
  };

  const data = [
    { value: notes, color: renderColorNotes() }, 
    { value: 100 - notes, color: '#D3D3D3' },
  ];

  const renderCustomizedLabel = ({ cx, cy }) => {
    return (
      <text
        x={cx}
        y={cy}
        fill="black"
        textAnchor="middle"
        dominantBaseline="central"
        style={{ fontSize: '1.3em', fontWeight: 'bold' }}
      >
        {notes}
      </text>
    );
  };

  return (
    <Box sx={styles.container} role="img" aria-label={t('note_accessibility.container_note_accessibility', {note: notes})}    >
      <PieChart width={80} height={80}>
        <Pie
          data={data}
          startAngle={90}
          endAngle={-270}
          innerRadius={25}
          outerRadius={40}
          fill="#8884d8"
          dataKey="value"
          labelLine={false}
          label={renderCustomizedLabel}
          aria-hidden={true}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
      <Box sx={styles.labelContainer}>
        <Typography aria-hidden="true">
          {t('note_accessibility.label_note_accessibility')}
        </Typography>
      </Box>
    </Box>
  );
};